const ScoreComponent = () => import('@/views/score/ScoreView')

export default [
    {
        path:'/ScoreIndex',
        name:'ScoreRouter',
        component:ScoreComponent
    }
]